const automations = {
  hubTitle: "Automation Hub",
  liveRegistry: "Live Registry",
  quickActions: "Quick Actions",
  runOrigamiSync: "Run Origami Sync",
  openN8n: "Open n8n",
  testHealth: "Test Health",
  sendTestNotification: "Send Test Notification",
  running: "Running...",
  actionSuccess: "Success",
  actionError: "Error",
  connections: "Connections",
  online: "Online",
  offline: "Offline",
  configured: "Configured",
  unconfigured: "Not configured",
  lastChecked: "Last checked",
  testConnection: "Test",
  checking: "Checking...",
  supabase: "Supabase",
  supabaseDesc: "Database, auth & Realtime",
  n8n: "n8n",
  n8nDesc: "Workflow engine",
  origami: "Origami CRM",
  origamiDesc: "Operations SOT",
  wati: "WATI WhatsApp",
  watiDesc: "Client messaging",
  notion: "Notion",
  notionDesc: "Tasks, specs & roadmap",
  tabEndpoints: "API Endpoints",
  tabJobs: "Scheduled Jobs",
  tabWebhooks: "Webhooks",
  tabSuggestions: "Suggestions",
  tabRssFeeds: "RSS",
  apiEndpoints: "API Endpoints",
  apiEndpointsDesc: "All active routes in the system",
  method: "Method",
  path: "Path",
  auth: "Auth",
  authPublic: "Public",
  authRequired: "JWT Required",
  authAdmin: "Admin",
  tryIt: "Try",
  scheduledJobs: "Scheduled Jobs",
  scheduledJobsDesc: "pg_cron & n8n workflows",
  pgCronJobs: "pg_cron Jobs",
  jobName: "Job Name",
  schedule: "Schedule",
  status: "Status",
  active: "Active",
  paused: "Paused",
  runNow: "Run Now",
  n8nWorkflows: "n8n Workflows",
  n8nOpenDashboard: "Open n8n Dashboard",
  n8nConfigureUrl: "Configure n8n URL in environment variables",
  cleanNotifications: "Clean old notifications",
  cleanNotificationsSchedule: "Daily at midnight",
  weeklyRecurringTasks: "Weekly recurring tasks",
  weeklyRecurringSchedule: "Every Sunday 08:00",
  origamiSync: "Origami Sync",
  origamiSyncSchedule: "Every hour",
  webhooks: "Incoming Webhooks",
  webhooksDesc: "Endpoints that receive data from external systems",
  source: "Source",
  purpose: "Purpose",
  copyUrl: "Copy URL",
  copied: "Copied!",
  showPayload: "Show Payload Example",
  hidePayload: "Hide",
  origamiSyncPurpose: "Sync projects from Origami",
  origamiEntitiesPurpose: "Sync entities from Origami",
  pushSubscribePurpose: "Browser push notification subscription",
  contractorSubmitPurpose: "New contractor form submission",
  suggestions: "Automation Suggestions",
  suggestionsDesc: "Things that can be automated — but aren't connected yet",
  difficulty: "Difficulty",
  impact: "Impact",
  easy: "Easy",
  medium: "Medium",
  hard: "Hard",
  high: "High",
  low: "Low",
  learnMore: "Learn More",
  collapse: "Collapse",
  sug1Title: "Auto-sync Origami on schedule",
  sug1Desc: "pg_cron calls /api/origami/sync every hour — no n8n needed",
  sug1Steps: "1. Enable pg_cron extension\n2. Create job calling the API route\n3. Ensure API key is configured",
  sug2Title: "WhatsApp notification on project status change",
  sug2Desc: "DB trigger + WATI API — automatic message to client",
  sug2Steps: "1. Create DB trigger on projects table\n2. On status change → call WATI API\n3. Configure template in WATI dashboard",
  sug3Title: "Weekly report email",
  sug3Desc: "pg_cron + Edge Function — activity summary every Sunday",
  sug3Steps: "1. Create Edge Function to aggregate stats\n2. Schedule with pg_cron every Sunday 08:00\n3. Send via Resend/SendGrid",
  sug4Title: "Auto-create tasks from Notion",
  sug4Desc: "n8n workflow — when a Notion task is added, it's created in the system too",
  sug4Steps: "1. Connect Notion trigger in n8n\n2. Map fields to tasks table\n3. Activate the workflow",
  sug5Title: "Nightly database backup",
  sug5Desc: "pg_cron — daily snapshot to backups table",
  sug5Steps: "1. Create db_backups table\n2. pg_cron job every night at 02:00\n3. Store backup metadata",
  sug6Title: "Entity change audit log",
  sug6Desc: "DB trigger — every entity change is logged automatically",
  sug6Steps: "1. Create entity_audit_log table\n2. Trigger on INSERT/UPDATE/DELETE\n3. Store old_value, new_value, user_id",
  // ─── Activity + Run History tabs ───
  tabActivity: "Activity",
  tabRunHistory: "Run History",
  // ─── Activity feed ───
  activityFeed: "Activity Feed",
  activityFeedDesc: "Recent system changes — real-time",
  activityTable: "Table",
  activityAction: "Action",
  activityRecord: "Record",
  activityUser: "User",
  activityTime: "Time",
  activityInsert: "Insert",
  activityUpdate: "Update",
  activityDelete: "Delete",
  activityNoEntries: "No activity yet",
  activityLive: "Live",
  // ─── Run history ───
  runHistory: "Run History",
  runHistoryDesc: "All manual and automated job runs",
  runJobName: "Job Name",
  runStatus: "Status",
  runDuration: "Duration",
  runTriggeredBy: "Triggered By",
  runStarted: "Started",
  runStatusRunning: "Running",
  runStatusSuccess: "Success",
  runStatusError: "Error",
  runNoEntries: "No runs yet",
  runLive: "Live",
  runMs: "ms",
  // ─── Cron history ───
  lastRun: "Last Run",
  lastRunNever: "Never run",
  lastRunStatus: "Last Run Status",
} as const;
export default automations;
